export default {
  header: 'Audit specification',
  specificationName: 'Specification name',
};
